<div class="wrpr">
    <div class="contentCard">
        <div class="pageName">
            <img src="../../../../assets/images/Manage_Requests_Icon_black.svg" alt="manage-users-icon" style="width: auto; height: 27px;">
            <h1>Manage Requests</h1>
        </div>
        <div class="announcementCont" *ngIf="getPendingRequestsCount() > 0 && !clearPendingReqBanner">
            <div class="leftblock">
                <img src="../../../../assets/images/dmint-ui-kit-foundation-icons-failed-message-filled.svg" alt="">
                <p>
                    <span>{{pendingItemsCount}} request{{pendingItemsCount > 1 ? 's' : ''}}</span>
                    waiting for you to take action.
                </p>
            </div>
            <a style="cursor: pointer;" (click)="clearPendingReqBanner = !clearPendingReqBanner">
                <img src="../../../../assets/images/Cross.svg" alt="">
            </a>
        </div>
        <div class="filtersCont new">
            <div class="nameAndIcon" (click)="toggleFiltersCont()">
                <img src="/assets/images/newFiltersIcon.svg" alt="" />
                <h4>
                    Filters
                    <span *ngIf="getSelectedFilterCount() > 0">({{getSelectedFilterCount()}} selected)
                    </span>
                </h4>

                <hr class="vertical" *ngIf="getSelectedFilterCount() > 0">

                <a (click)="resetAllFilters()" class="dmintLinkBtn red" style="margin-top: 5px; padding: 0;" *ngIf="getSelectedFilterCount() > 0">
                    Reset all
                </a>
            <img style="margin-left: auto;" class="" src="/assets/images/chevron-south.svg" alt=""/>
            </div>
            <div class="filtersBox" *ngIf="isFilterOpen">
                <form class="filtersBox" [formGroup]="dataRequestForm">
                    <div class="filterType">
                        <div class="formControl">
                            <input
                                id="searchTerm"
                                name="searchTerm"
                                type="text"
                                [(ngModel)]="searchTerm"
                                [ngModelOptions]="{standalone: true}"
                               (keyup.enter)="onSearchChange()"
                                placeholder="Search..."
                                class="searchField"
                            />
                             <button type="button" *ngIf="searchTerm" class="clear-btn" (click)="searchTerm=''; onAdvancedFilter()">
                            &#x2715;
                        </button>
                        </div>
                        <div class="formControl">
                            <label for="Category" class="label">Category</label>
                            <!-- <app-lib-multi-select
                                [labelText]="'Category'"
                                [noLabel]="false"
                                [isReq]="false"
                                [options]="categoryOptions"
                                [isMultiSelect]="true"
                                [selectedItems]="selectedCategory()"
                                [isDropdownOpen]="openDropdownKey === 'category'"
                                (toggleDropdown)="onMultiSelectDropdownToggle('category')"
                                (selectionChange)="onCategorySelectionChange($event)"
                                >
                            </app-lib-multi-select> -->
                            <ng-multiselect-dropdown style="width: 100%;"
                                [placeholder]="'Select'"
                                [settings]="categoryTypeFilterDropdownSettings"
                                formControlName="categoryType"
                                [data]="categoryOptions"
                                (onSelect)="onCategorySelect($event)"
                                (onDeSelect)="onCategoryDeselect($event)"
                                (onSelectAll)="onSelectAllCategoryTypes($event)"
                                (onDeSelectAll)="onDeSelectAllCategoryTypes($event)"
                                >
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="formControl">
                            <label for="updatedOn" class="label">Updated on</label>
                            <!-- <input 
                                type="date" 
                                id="updatedOn" 
                                formControlName="updatedOn" 
                                class="inputField"
                                style="
                                    margin-top: 5px; width: 100%; height: 3.5rem; font-size: 1rem; line-height: 1.5; padding: .938rem 1rem; position: relative; display: flex; align-items: center; justify-content: space-between; background: #fff; border-radius: .25rem; border: 1px solid #F5F5F5; box-shadow: 0 0 14px #00000026;"
                                /> -->
                                <mat-form-field>
                                    <mat-date-range-input [formGroup]="updatedOn" [rangePicker]="picker2"  [max]="maxDate">
                                        <input readonly matStartDate formControlName="startDate" placeholder="Start Date">
                                        <input readonly matEndDate formControlName="endDate" placeholder="End Date"
                                        (dateChange)="onDateSelected()" >
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker2></mat-date-range-picker>
                                </mat-form-field>
                                <div *ngIf="updatedOn.errors?.['endBeforeStart']" class="error">
                                    End date cannot be before start date.
                                </div>
                        </div>
                        <div class="formControl">
                            <!-- <app-lib-multi-select
                                displayKey="statusName"
                                [labelText]="'Status'"
                                [noLabel]="false"
                                [isReq]="false"
                                [options]="statusOptions"
                                [isMultiSelect]="true"
                                [selectedItems]="selectedStatus()"
                                [isDropdownOpen]="openDropdownKey === 'status'"
                                (toggleDropdown)="onMultiSelectDropdownToggle('status')"
                                (selectionChange)="onStatusSelectionChange($event)"
                                >
                            </app-lib-multi-select> -->
                            <label for="Status" class="label">Status</label>
                          
                            <ng-multiselect-dropdown style="width: 100%;"
                                [placeholder]="'Select'"
                                [settings]="statusFilterDropdownSettings"
                                formControlName="statusType"
                                [data]="statusOptions"
                                (onSelect)="onStatusSelect($event)"
                                (onDeSelect)="onStatusDeselect($event)"
                                (onSelectAll)="onSelectAllStatusTypes($event)"
                                (onDeSelectAll)="onDeSelectAllStatusTypes($event)"
                                >
                            </ng-multiselect-dropdown>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="kpiCont">
      <p *ngIf="filterData?.length>0">
        Showing {{ (page - 1) * itemsPerPage + 1 }} -
        {{ page * itemsPerPage < totalItems ? page * itemsPerPage : totalItems }} of
        {{ totalItems }}
       </p>
       <p *ngIf="filterData?.length==0">Showing 0 of 0 Result</p>
        </div>
        <div class="tableCont" >
            <div class="table" *ngIf="filterData?.length>0">
                <div class="tHead">
                    <div class="tCol"  *ngFor="let column of columns;let i=index" >
                        {{column}}
                        <span *ngIf="(column == 'Updated On')"
                            class="down-arrow-icon" (click)="onSort(column,i)" onKeyPress=""
                            [class.rotate]="isAscending">
                            <img src="../../../assets/images/chevron-down.svg" alt="chevron_icon" /></span>
                    </div>
                </div>
                <div class="tRow" *ngFor="let item of filterData | paginate
                  : {
                      id: 'listing_pagination',
                      itemsPerPage: itemsPerPage,
                      currentPage: page,
                      totalItems: totalItems
                    }">
                    <div class="tCol">
                        {{item.accessRequestId}}
                    </div>
                    <div class="tCol">
                        <span class="truncateText">
                            {{item.headerName}}
                        </span> 
                    </div>
                    <div class="tCol">
                        <span class="truncateText">
                            {{item.moduleName}}
                        </span> 
                    </div>
                    <div class="tCol">
                        {{item.submittedByName}}
                        <span class="userEmail">
                            <span class="truncateEmail">
                                {{item.submittedByEmail}} 
                            </span>
                            <span class="copyIconWrapper" 
                                  (mouseenter)="showCopyTooltip(item.accessRequestId, $event)"
                                  (mouseleave)="hideCopyTooltip()"
                                  (click)="copyEmailToClipboard(item.submittedByEmail, $event)">
                                <img src="../../../../assets/images/copyIcon.svg" alt="Copy-Email" style="cursor: pointer;">
                                <span class="copyTooltip" 
                                      *ngIf="showTooltip && tooltipEmail === item.accessRequestId">
                                    {{tooltipMessage}}
                                </span>
                            </span>
                        </span>
                    </div>
                    <div class="tCol">
                        <span class="truncateText">
                            {{item.companyName}}
                        </span> 
                    </div>
                    <div class="tCol">
                        {{item.updatedDate}}
                    </div>
                    <div class="tCol">
                        <span class="statusPill"
                        [ngClass]="
                            item.statusName === 'APPROVED'
                            ? 'completed_chip'
                            : item.statusName === 'REJECTED'
                            ? 'failed_chip'
                            : item.statusName === 'PENDING'
                            ? 'processing_chip'
                            : item.statusName === 'IN PROGRESS'
                            ? 'in_progress_chip'
                            : ''
                        "
                        >{{item.statusName}}</span>
                    </div>
                    <div class="tCol">
                        <button class="dmintLinkBtn" [disabled]="false"
                        [ngClass]="
                            item.statusName === 'APPROVED'
                            ? 'completed_chip'
                            : item.statusName === 'REJECTED'
                            ? 'failed_chip'
                            : item.statusName === 'PENDING' || item.statusName === 'IN PROGRESS'
                            ? 'processing_chip'
                            : ''
                        "
                        (click)="openRequestDetailsPopup(item)" [disabled]="item.statusName === 'IN PROGRESS'"
                        >
                            {{item.statusName === 'APPROVED' || item.statusName === 'REJECTED' ? 'View' : 'Take Action'}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="paginationCont" *ngIf="filterData?.length > 0">
              <pagination-controls id="listing_pagination"
                    (pageChange)="getPage($event)"
                    [maxSize]="5" 
                    previousLabel="Prev"
                    nextLabel="Next">
                </pagination-controls>
            </div>
             <!-- <div class="pagination">
                <button (click)="getPage(currentPage - 1)" [disabled]="currentPage === 1">Prev</button>
                <button *ngFor="let page of getPageNumbers()" [ngClass]="{active: page === currentPage}" (click)="getPage(page)">
                    {{page}}
                </button>
                <button (click)="getPage(currentPage + 1)" [disabled]="currentPage === getPageNumbers().length">Next</button>
              </div> -->
        </div>
      <ng-container *ngIf="filterData?.length === 0">
        <div class="noResults">
            <img src="/assets/images/noResults.png" alt="no-results" />
            <p>No results found.</p>
        </div>
      </ng-container>
   
    </div>
      <div class="popupCont" *ngIf="isPopupOpen&&selectedRequest" (click)="closePopup()">
        <div class="popupModal" (click)="$event.stopPropagation()">
            <div class="popupHeader">
                <h2
                style="display: inline-flex; align-items: center; gap: 16px;">Access Request Details 
                    <span *ngIf="selectedRequest?.status !== 'PENDING' && selectedRequest?.status === 'APPROVED'" class="statusPill completed_chip">{{selectedRequest?.status}}</span>
                    <span *ngIf="selectedRequest?.status !== 'PENDING' && selectedRequest?.status === 'REJECTED'" class="statusPill failed_chip">{{selectedRequest?.status}}</span>
                </h2>
                <img src="../../../../assets/images/closeIcon-16x16.svg" alt="Close" (click)="closePopup()" style="cursor: pointer;">
            </div>
            <div class="scrollB">
            <div class="metadataCont" *ngIf="hasMetadata()">
                <div class="metadataItem" *ngFor="let key of getMetadataKeys()">
                    <span class="metadataLabel">{{ key }}:</span>
                    <span class="metadataValue">{{ metadata[key] }}</span>
                </div>
            </div>
            <div class="RequestedUG" [ngClass]="{'orderOne': selectedRequest?.status === 'APPROVED'}">
                <h3>Requested User Groups <span>{{selectedUserGroupCount()}} selected</span></h3>
                <div class="availableOptions">
                    <div class="optionsContainer" *ngIf="selectedRequest?.status ==='PENDING'">
                       
                        <button 
                            *ngFor="let option of allUserGroupOptions"
                            class="optionChip"
                            [class.selected]="isUserGroupSelected(option)"
                            (click)="selectedUserGroupCount() === 1 && isUserGroupSelected(option) ? null : toggleUserGroup(option)"
                            [style.cursor]="selectedUserGroupCount() === 1 && isUserGroupSelected(option) ? 'default' : 'pointer'">
                            {{ option.userGroupName }}
                            <span *ngIf="isUserGroupSelected(option) && selectedUserGroupCount() > 1" class="removeIcon">×</span>
                        </button>
                    </div>
                    <div class="optionsContainer" *ngIf="selectedRequest?.status !=='PENDING'">
                        <button 
                            *ngFor="let option of allUserGroupOptions"
                            class="optionChip selected"
                            >
                            {{ option.userGroupName }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="availableSubs" *ngIf="selectedRequest?.status !== 'REJECTED'">
                <div class="subsHeader">
                    <p class="note" *ngIf="selectedRequest?.status !=='PENDING'">Subscription Name</p>
                    <p class="note" *ngIf="selectedRequest?.status ==='PENDING'">Select Subscription for the user</p>
                    <button class="secondary" *ngIf="userType=='DMINT Admin' && selectedRequest?.status == 'PENDING' && !isCreatingNewSubscription" (click)="createNewSubscription()">Create new subscription</button>
                </div>
                
                <!-- New subscription creation form -->
             <div *ngIf="isCreatingNewSubscription">
                 <form  class="newSubscriptionForm" [formGroup]="newSubscriptionFormGroup">
                    <div class="formRow">
                        <label for="subName">Subscription Name:<span style="color:red">*</span></label>
                        <input required
                            type="text" 
                            id="subName"
                            formControlName="subscriptionName"
                            placeholder="Enter subscription name"
                            class="searchField"/>
                        <div *ngIf="newSubscriptionFormGroup.get('subscriptionName')?.hasError('required') && newSubscriptionFormGroup.get('subscriptionName')?.touched" class="errorText">Subscription name is required
                    </div>
                        <div *ngIf="newSubscriptionFormGroup.get('subscriptionName')?.hasError('subscriptionExists') && newSubscriptionFormGroup.get('subscriptionName')?.touched" class="errorText">Subscription name already exists
                    </div>
                    </div>
                    <div class="formRow">
                        <label class="required" for="subCreatedOn">Created On:<span style="color:red">*</span></label>
                            <mat-form-field>
                                <input formControlName="startDate" required placeholder="DD/MM/YYYY" readonly matInput [matDatepicker]="picker1"  [min]="minDate">
                                <mat-datepicker #picker1></mat-datepicker>
                                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field> 
                            <div *ngIf="newSubscriptionFormGroup.get('startDate')?.hasError('required') && newSubscriptionFormGroup.get('startDate')?.touched" class="errorText">Created on is required
                                </div>
                    </div>
                    <div class="formRow">
                        <label class="required" for="subExpiryDate">Expiry Date:<span style="color:red">*</span></label>
                            <mat-form-field>
                                <input (dateChange)="endDate($event)" formControlName="endDate" required placeholder="DD/MM/YYYY" readonly matInput [matDatepicker]="picker2" [min]="minExpiryDate">
                                <mat-datepicker #picker2></mat-datepicker>
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker2></mat-date-range-picker>
                            </mat-form-field> 
                            <div *ngIf="newSubscriptionFormGroup.get('endDate')?.hasError('required') && newSubscriptionFormGroup.get('endDate')?.touched" class="errorText">Expiry date is required
                            </div>
                            <div *ngIf="newSubscriptionFormGroup.hasError('dateRangeInvalid') && (newSubscriptionFormGroup.get('startDate')?.touched || newSubscriptionFormGroup.get('endDate')?.touched)" class="errorText">Expiry date must be greater than start date
                            </div>
                    </div>
                    <div class="formActions">
                        <button class="doneBtn" (click)="saveNewSubscription()"><span class="check"></span></button>
                        <button class="cancelBtn" (click)="cancelNewSubscription()"><span class="cross"></span></button>
                    </div>
                </form>
                </div>

                <div class="subsList" *ngIf="selectedRequest?.status === 'PENDING'">
                    <div class="subItem" *ngFor="let sub of availableSubscriptions">
                        <input 
                            type="radio" 
                            name="subscription" 
                            [value]="sub.subscriptionId" 
                            [checked]="newSubscriptionFormGroup.get('subscriptionId').value === sub.subscriptionId"
                            (change)="onSubscriptionSelect(sub)" />
                        <div class="subDetails">
                            <span class="subName"  matTooltip="{{sub.subscriptionName}}">{{ sub.subscriptionName }}</span>
                            <span class="subInfo">({{ sub.startDate | date: 'yyyy-MM-dd' }} - {{ sub.endDate | date: 'yyyy-MM-dd' }})</span>
                        </div>
                    </div>
                </div>
                <div class="subsList" *ngIf="selectedRequest?.status === 'APPROVED'">
                    <div class="subItem">
                        <div class="subDetails">
                            <span class="subName" matTooltip="{{selectedRequest?.subscriptionName}}">{{selectedRequest?.subscriptionName}}</span>
                            <span class="subInfo">({{selectedRequest?.subscriptionStartDate}} - {{selectedRequest?.subscriptionEndDate}})</span>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="formRow" [ngClass]="{'orderOne': selectedRequest?.status === 'APPROVED'}">
                <label for="notes" *ngIf="selectedRequest?.status !=='PENDING'">Additional Comments</label>
                <p class="comment" *ngIf="selectedRequest?.status !=='PENDING'">{{selectedRequest.remarks}}</p>
                <label for="notes" *ngIf="selectedRequest?.status ==='PENDING'">Please provide comment for the Approve/Reject<span style="color:red">*</span></label>
                <textarea id="notes" *ngIf="selectedRequest?.status ==='PENDING'" [(ngModel)]="newSubscriptionForm.remarks" rows="1" class="notesField"></textarea>
            </div>
            <div class="ctaCont" [ngClass]="{'orderOne': selectedRequest?.status === 'APPROVED'}">
                <button class="primary red" *ngIf="selectedRequest?.status == 'PENDING'" (click)="acceptOrRejectRequest(selectedRequest?.accessRequestId,'Rejected')">Reject</button>
                <button class="primary" *ngIf="selectedRequest?.status == 'PENDING'" (click)="acceptOrRejectRequest(selectedRequest?.accessRequestId,'Approved')">Approve</button>
                <button class="dmintLinkBtn completed_chip" *ngIf="selectedRequest?.status === 'APPROVED' || selectedRequest?.status === 'REJECTED'" (click)="closePopup()">Close</button>
            </div>
        </div>
    </div>
</div>
<app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>
<app-error-toast *ngIf="error" [message]="error"></app-error-toast>
<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandlerSub()"></app-alert>